import * as THREE from "three";
import jsPDF from "jspdf";
import Experience from "./Experience";
// import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer"
// import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass"
// import { GammaCorrectionShader } from "three/examples/jsm/shaders/GammaCorrectionShader"
// import { DotScreenPass } from "three/examples/jsm/postprocessing/DotScreenPass"
// import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
// import { SMAAPass } from "three/examples/jsm/postprocessing/SMAAPass"
// import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass"

export default class Renderer {

    constructor() {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        this.debug = this.experience.debug


        this.setIstance()

        if (this.debug.active) {

            this.debugFolder = this.debug.ui.addFolder('Post Processing')

            // this.setGui()
        }

        // this.select = document.getElementById('pdf-download')
        // this.select.addEventListener('click', () => {

        //     this.downloadPDF()
        // })
    }

    setIstance() {

        this.istance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha: true,
            preserveDrawingBuffer: true
        })
        this.istance.physicallyCorrectLights = true
        this.istance.outputEncoding = THREE.sRGBEncoding
        this.istance.toneMapping = THREE.CineonToneMapping
        this.istance.toneMappingExposure = 1.75
        this.istance.shadowMap.enabled = true
        this.istance.shadowMap.type = THREE.PCFSoftShadowMap
        this.istance.setClearColor('#211d20')
        this.istance.setSize(this.sizes.width, this.sizes.height)
        this.istance.setPixelRatio(this.sizes.pixelRatio)
        this.istance.setClearAlpha(0)

        // this.renderTarget = new THREE.WebGLRenderTarget(
        //     800,
        //     600,
        //     {
        //         samples: this.istance.getPixelRatio() === 1 ? 2 : 0
        //     }
        // )

        // this.effectComposer = new EffectComposer(this.istance, this.renderTarget)
        // this.effectComposer.setSize(this.sizes.width, this.sizes.height)
        // this.effectComposer.setPixelRatio(this.sizes.pixelRatio)

        // this.renderPass = new RenderPass(this.scene, this.camera.istance)
        // this.effectComposer.addPass(this.renderPass)

        // this.dotScreenPass = new DotScreenPass()
        // this.effectComposer.addPass(this.dotScreenPass)

        // this.gammaCorrectionPass = new ShaderPass(GammaCorrectionShader)
        // this.gammaCorrectionPass.enabled = true
        // this.effectComposer.addPass(this.gammaCorrectionPass)

        // this.smaaPass = new SMAAPass()
        // this.smaaPass.enabled = false
        // this.effectComposer.addPass(this.smaaPass)

        // this.unrealBloomPass = new UnrealBloomPass()
        // this.unrealBloomPass.enabled = false
        // this.unrealBloomPass.strength = 0.3
        // this.unrealBloomPass.radius = 1
        // this.unrealBloomPass.threshold = 0.6
        // this.effectComposer.addPass(this.unrealBloomPass)


    }

    downloadPDF() {
        console.log(this.istance);
        let orientation
        let pdfWidth
        let pdfHeight

        const originalWidth = this.sizes.width
        const originalHeight = this.sizes.height
        const ratio = originalWidth / originalHeight

        let newWidth
        let newHeight

        if (this.sizes.width > this.sizes.height) {
            orientation = "landscape"
            pdfWidth = 297
            pdfHeight = 210

            newWidth = pdfWidth
            newHeight = newWidth / ratio
        } else {
            orientation = "portrait"
            pdfWidth = 210
            pdfHeight = 297

            newHeight = pdfHeight
            newWidth = pdfHeight * ratio
        }

        // let imageData = ctx.toDataURL("image/png", 1.0)
        let imageData = this.istance.domElement.toDataURL("image/png", 1.0)
        // console.log(imageData);
        let pdf = new jsPDF(orientation)

        const x = (pdf.internal.pageSize.width / 2) - (newWidth / 2)
        const y = (pdf.internal.pageSize.height / 2) - (newHeight / 2)

        pdf.addImage(imageData, "PNG", x, y, newWidth, newHeight)
        pdf.save("canvas.pdf")

    }

    setGui() {
        this.debugFolder.add(this.unrealBloomPass, 'enabled')
        this.debugFolder.add(this.unrealBloomPass, 'strength').min(0).max(2).step(0.001)
        this.debugFolder.add(this.unrealBloomPass, 'radius').min(0).max(2).step(0.001)
        this.debugFolder.add(this.unrealBloomPass, 'threshold').min(0).max(1).step(0.001)
    }

    resize() {
        this.istance.setSize(this.sizes.width, this.sizes.height)
        this.istance.setPixelRatio(this.sizes.pixelRatio)
        // this.effectComposer.setSize(this.sizes.width, this.sizes.height)
        // this.effectComposer.setPixelRatio(this.sizes.pixelRatio)
    }

    update() {
        this.istance.render(this.scene, this.camera.istance)
        // this.effectComposer.render()
    }
}